import RoleForm from '../../../../components/Main/Group/Roles/RoleForm'
import React from 'react'
import { Modal } from 'antd'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'

function RolesListModal(props) {
  const {
    remove,
    submit,
    update,
    visible,
    modalType,
    formRef,
    onCancel,
    removing,
    submitting,
  } = props
  const isNew = modalType === 'new'
  return (
    <Modal
      visible={visible}
      title={'Role'}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={
        <FooterButtons
          submit={submit}
          remove={remove}
          update={update}
          removing={removing}
          submitting={submitting}
          title={'Days'}
          isNew={isNew}
          isEdit={!isNew}
        />
      }
      width={'75%'}>
      <RoleForm ref={formRef} {...props} />
    </Modal>
  )
}

RolesListModal.propTypes = {}
RolesListModal.defaultProps = {}

export default RolesListModal
